// Psychological rounding for second-hand prices. Apply to FINAL prices shown to
// the user (estimated value, strategy prices, listing price) — AFTER any
// percentage maths, never on intermediate values.
export const formatUsedPrice = (price) => {
  const p = Number(price) || 0;
  if (p < 100) return Math.round(p);          // 54.82 -> 55
  if (p < 1000) return Math.round(p / 10) * 10; // 467.69 -> 470
  return Math.round(p / 50) * 50;               // 2134 -> 2150
};

// Integer display, no decimals, with it-IT thousands separator.
export const displayUsedPrice = (price) => formatUsedPrice(price).toLocaleString("it-IT");
